'use client';

import Link from 'next/link';
import { FC } from 'react';
import Icon from '~/components/icon';
import { YMGoal, useMetrika } from '~/providers/ya-metrica';
import emailHref from '~/utils/email-href';
import phoneHref from '~/utils/phone-href';

import styles from './styles.module.css';

interface Props {
  phone: string | null;
  email: string | null;
}

const Contacts: FC<Props> = ({ phone, email }) => {
  const { captureGoal } = useMetrika();

  const onPhoneClick = () => {
    captureGoal(YMGoal.NUMBER_CLICK);
  };

  const onEmailClick = () => {
    captureGoal(YMGoal.EMAIL_CLICK);
  };

  return (
    <div className={styles.contactContainer}>
      {phone && (
        <Link onClick={onPhoneClick} href={phoneHref(phone)} className={styles.contact}>
          <Icon name="phone" className={styles.icon} />
          {phone}
        </Link>
      )}
      {email && (
        <Link onClick={onEmailClick} href={emailHref(email)} className={styles.contact}>
          <Icon name="email" className={styles.icon} />
          {email}
        </Link>
      )}
    </div>
  );
};

export default Contacts;
